export default function DayOneAttyStatus({case_kpi}) {
    return <span>
        {case_kpi && case_kpi.attorney_day_1_status ? <>Day one status: <strong>{case_kpi.attorney_day_1_status}</strong></>
        :
        <>Day one status: <strong>No status received from Salesforce yet.</strong></>
        } Attorney ever signed: <strong>{case_kpi && case_kpi.attorney_signed ? 'Yes' : 'No'}</strong>
    </span>
}
